// ObraCore Design System — Tokens
export const obracore = {
  colors: {
    brand: "#E03131",
    brandDark: "#0B0F14",
    brandLight: "#fef2f2",
  },
  font: "'Plus Jakarta Sans', sans-serif",
  fontMono: "'Space Mono', monospace",
};
// Estado visual
export const status = {
  ok: { bg: "#f0fdf4", color: "#166534", dot: "#22c55e" },
  warn: { bg: "#fef9c3", color: "#92400e", dot: "#f59e0b" },
  crit: { bg: "#fef2f2", color: "#991b1b", dot: "#ef4444" },
};
// Módulos — colores por app
export const moduleColors = {
  meetings: { accent: "#7A0C2E", iconBg: "#fef2f2", iconStroke: "#7A0C2E" },
  rooms: { accent: "#1d4ed8", iconBg: "#eff6ff", iconStroke: "#1d4ed8" },
  legal: { accent: "#92400e", iconBg: "#fef9c3", iconStroke: "#92400e" },
  cauciones: { accent: "#166534", iconBg: "#f0fdf4", iconStroke: "#166534" },
  presupuestos: { accent: "#7c3aed", iconBg: "#f5f3ff", iconStroke: "#7c3aed" },
  hys: { accent: "#0EA5E9", iconBg: "#f0f9ff", iconStroke: "#0EA5E9" },
  equipos: { accent: "#B45309", iconBg: "#fef3c7", iconStroke: "#B45309" },
};
// Íconos SVG por app (paths de Lucide)
export const moduleIcons = {
  meetings: {
    viewBox: "0 0 24 24",
    paths: [
      "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2",
      "M23 21v-2a4 4 0 0 0-3-3.87",
      "M16 3.13a4 4 0 0 1 0 7.75",
    ],
    circles: [{ cx: 9, cy: 7, r: 4 }],
  },
  rooms: {
    viewBox: "0 0 24 24",
    paths: ["M3 9h18", "M9 21V9"],
    rects: [{ x: 3, y: 3, width: 18, height: 18, rx: 2 }],
  },
  legal: {
    viewBox: "0 0 24 24",
    paths: ["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"],
  },
  cauciones: {
    viewBox: "0 0 24 24",
    paths: ["M16 7V5a4 4 0 0 0-8 0v2"],
    rects: [{ x: 2, y: 7, width: 20, height: 14, rx: 2 }],
    circles: [{ cx: 12, cy: 14, r: 1 }],
  },
  presupuestos: {
    viewBox: "0 0 24 24",
    paths: [
      "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z",
      "M14 2v6h6",
      "M16 13H8",
      "M16 17H8",
      "M10 9H8",
    ],
  },
  hys: {
    viewBox: "0 0 24 24",
    paths: ["M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z", "M9 12l2 2 4-4"],
  },
  equipos: {
    viewBox: "0 0 24 24",
    paths: [
      "M1 3h15v13H1z",
      "M16 8h4l3 3v5h-7V8z",
      "M5.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
      "M18.5 21a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z",
    ],
  },
};
export const base = {
  radius: "14px",
  radiusSm: "8px",
  shadow: "0 6px 24px rgba(0,0,0,0.07)",
  border: "1px solid #eaeaea",
  transition: "box-shadow 0.2s, transform 0.15s",
};